<template>
  <div>
    <button class="button is-primary is-small" @click="open">
      Abrir Buscador
    </button>
    <br /><br />
  </div>
</template>
<script>
import SearchDocument from "./SearchDocument";

export default {
  data() {
    return {};
  },
  methods: {
    async open() {
      this.$buefy.modal.open({
        parent: this,
        component: SearchDocument,
        hasModalCard: true,
        fullScreen:true,
        customClass: "custom-class custom-class-2",
        trapFocus: true,
      });
    },
  },
};
</script>